import { AccountIcon } from 'src/components/icons/AccountIcon'

type Props = {
  className?: string
}

export const UserIconWrapper = ({ className }: Props) => {
  return (
    <span
      className={`flex justify-center items-center flex-shrink-0 p-1 w-8 h-8 rounded-full border border-solid border-yellow-200 relative ${
        className ?? ''
      }`}
    >
      <AccountIcon />
    </span>
  )
}
